/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-tabs */
import { createRouter, createWebHashHistory } from 'vue-router'
// import Home from '../views/Home'

  const routes = [
    {
      meta: {
        title: 'Dashboard',
        requireLogin: true
      },
      path: '/home',
      name: 'home',
      component: () => import(/* webpackChunkName: "login" */ '../views/Home')
      // component: Home
    },
    {
      meta: {
        title: 'Login',
        fullScreen: true
      },
      path: '/login',
      name: 'Login',
      component: () => import(/* webpackChunkName: "login" */ '../views/Login')
    },
    {
      meta: {
      title: 'Document Category',
      requireLogin: true
      },
      path: '/doc-category',
      name: 'docCategory.index',
      component: () => import(/* webpackChunkName: 'class.index' */ '../views/docManagement/docCategory/Index.vue')
    },
    {
      meta: {
      title: 'Programme',
      requireLogin: true
      },
      path: '/programme',
      name: 'programme.index',
      component: () => import(/* webpackChunkName: 'class.index' */ '../views/docManagement/programme/Index.vue')
    },
    {
      meta: {
      title: 'Training',
      requireLogin: true
      },
      path: '/training',
      name: 'training.index',
      component: () => import(/* webpackChunkName: 'class.index' */ '../views/docManagement/employeetraining/Index.vue')
    },
    {
      meta: {
      title: 'Student',
      requireLogin: true
      },
      path: '/student',
      name: 'student.index',
      component: () => import(/* webpackChunkName: 'class.index' */ '../views/docManagement/student/Index.vue')
    },
    {
      meta: {
      title: 'Alumni',
      requireLogin: true
      },
      path: '/alumni',
      name: 'alumni.index',
      component: () => import(/* webpackChunkName: 'class.index' */ '../views/docManagement/Alumni/Index.vue')
    },
    {
      meta: {
      title: 'Comboard',
      requireLogin: true
      },
      path: '/comboard',
      name: 'comboard.index',
      component: () => import(/* webpackChunkName: 'class.index' */ '../views/docManagement/Comboard/Index.vue')
    },
    {
      meta: {
      title: 'Registration',
      requireLogin: true
      },
      path: '/registration',
      name: 'registration.index',
      component: () => import(/* webpackChunkName: 'class.index' */ '../views/docManagement/Registration/Index.vue')
    },
    {
      meta: {
      title: 'Event',
      requireLogin: true
      },
      path: '/event',
      name: 'event.index',
      component: () => import(/* webpackChunkName: 'class.index' */ '../views/docManagement/Event/Index.vue')
    },
    {
      meta: {
      title: 'News',
      requireLogin: true
      },
      path: '/news',
      name: 'news.index',
      component: () => import(/* webpackChunkName: 'class.index' */ '../views/docManagement/News/Index.vue')
    },
    {
      meta: {
      title: 'Candidate',
      requireLogin: true
      },
      path: '/candidate',
      name: 'candidate.index',
      component: () => import(/* webpackChunkName: 'class.index' */ '../views/docManagement/Candidates/Index.vue')
    },
    {
      meta: {
      title: 'Mass Upload',
      requireLogin: true
      },
      path: '/upload',
      name: 'massUpload.index',
      component: () => import(/* webpackChunkName: 'class.index' */ '../views/docManagement/MassUpload/Index.vue')
    },
    {
      meta: {
      title: 'Employee Upload',
      requireLogin: true
      },
      path: '/employee',
      name: 'employeeUpload.index',
      component: () => import(/* webpackChunkName: 'class.index' */ '../views/referensi/employee/Index.vue')
    },
    {
      meta: {
      title: 'Project Administration',
      requireLogin: true
      },
      path: '/administration',
      name: 'Administration.index',
      component: () => import(/* webpackChunkName: 'class.index' */ '../views/docManagement/Administration/Index.vue')
    },
    {
      meta: {
        title: 'Login',
        fullScreen: true
      },
      path: '/login',
      name: 'Login',
      component: () => import(/* webpackChunkName: "login" */ '../views/Login')
    },
    {
      meta: {
        title: 'Error',
        fullScreen: true
      },
      path: '/error',
      name: 'error',
      component: () => import(/* webpackChunkName: 'error' */ '../views/Error')
    }
  ]

  const router = createRouter({
    history: createWebHashHistory(),
    scrollBehavior (to, from, savedPosition) {
      return savedPosition || { top: 0 }
    },
    routes
  })

  router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requireLogin)) {
      if (to.path === '/') {
        next({ path: '/home' })
        return
      }
    }
    if (to.path === '/') {
      next({ path: '/login' })
      return
    }
    next()
  })
  export default router
